import React, { useState } from 'react';
import '../../../assignments/assignments.scss';
import {
  useGetPreviewAssignmentInfoMutation,
  useGetQuestionDetailsMutation,
  useRemoveQuestionMutation,
  useReorderQuestionMutation,
  useMoveQuestionMutation
} from '../../../../features/authentication/assignmentApislice';
import QuestionDetail from '../../../assignments/components/QuestionDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faCircleQuestion,
  faPlus,
  faTrashAlt,
  faShuffle,
  faUserGraduate,
  faChartPie,
  faInfo
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import EditAssignmentOptionsModal from './Components/EditAssignmentOptionsModal';
import CustomToast from '../../../../components/Toast';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import { useLocation } from 'react-router-dom';
import AssignmentPreviewHeader from '../../../assignments/components/AssignmentPreviewHeader';
import QuestionPreviewTypes from '../../../../enums/questionPreviewTypes';
import { useNavigate } from 'react-router-dom';
import { DateFormatter } from '../../../../utils/DateFormatter';
import { useAssignmentContext } from '../../context';
import AssignedViaModal from '../../../../components/AssignedViaModal/index';
import Languages from '../../../../enums/languages';

function EditAssignment() {
  const { Id } = useParams();
  const questionsPerPage = 24;
  const [selectedQuestionIndex, setSelectedQuestionIndex] = React.useState(0);
  const [getPreviewAssignmentInfo] = useGetPreviewAssignmentInfoMutation();
  const [getQuestionDetails] = useGetQuestionDetailsMutation();
  const [removeQuestion] = useRemoveQuestionMutation();
  const [reorderQuestion] = useReorderQuestionMutation();
  const [moveQuestion] = useMoveQuestionMutation();
  const [questions, setQuestions] = React.useState({});
  const [questionDetails, setQuestionDetails] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(0);
  const [qSetChange, setQSetChange] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [questionOpen, setQuestionOpen] = useState(true);
  const [selectedMcStyle, setSelectedMcStyle] = useState('');
  const [PAGE_SIZE, setPAGE_SIZE] = useState(questionsPerPage);
  const questionCount = questions?.questionIds?.length;
  const numPages = Math.ceil(questionCount / PAGE_SIZE);
  const startIndex = currentPage * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const pageQuestionIds = questions?.questionIds?.slice(startIndex, endIndex);
  const [dropIndex, setDropIndex] = useState(null);
  const [confirmModel, setConfirmModel] = useState(false);
  const [confirmModelSelected, SetConfirmModelSelected] = useState('');
  const [currentQuestionId, setCurrentQuestionId] = useState(0);
  const [questionCourseId, setQuestionCourseId] = useState(null);
  const location = useLocation();
  const { assignedStatus, mcChoices } = location.state;
  const navigate = useNavigate();
  const [isDragging, setIsDragging] = useState(false);
  const { assignmentAssignedViaDetails, setAssignmentAssignedViaDetails } = useAssignmentContext();
  const [showAssignmentMethodModal, setShowAssignmentMethodModal] = useState(false);
  const [assignedViaNeedsSet, setAssignedViaNeedsSet] = useState(false);
  const [isBlockedQuestion, setIsBlockedQuestion] = useState(false);

  React.useEffect(() => {
    getPreviewHandler();
    getQuestionDetailsHandler(0);
  }, []);

  React.useEffect(() =>{
    if(!showAssignmentMethodModal && assignmentAssignedViaDetails.id && assignedViaNeedsSet){
      navigate(`/assignments/${Id}/manage_assign/assign_to_students`);
    }
  },[showAssignmentMethodModal]);

  React.useEffect(() => {
    if (questions?.questionIds?.length > 0 && startIndex < questions?.questionIds?.length) {
      getQuestionDetailsHandler(startIndex);
    }
  }, [qSetChange]);

  const getQuestionDetailsHandler = async (index) => {
    setIsLoading(true);
    setSelectedQuestionIndex(index);
    let option = { Id, questionNo: index + 1, languageId: Languages.English };
    try {
      const response = await getQuestionDetails(option).unwrap();
      setCurrentQuestionId(response.questionId);
      setQuestionCourseId(response.questionCourseId);
      if(response?.blockedText)
        setIsBlockedQuestion(true);
      else
        setIsBlockedQuestion(false);
      setQuestionDetails(response);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const getPreviewHandler = async () => {
    const option = { assignmentId: Id };
    try {
      const response = await getPreviewAssignmentInfo(option).unwrap();
      setSelectedMcStyle(response.mcStyle);
      setQuestions(response);
      setAssignmentAssignedViaDetails({ id: response.assignedViaId });
    } catch (error) {
      console.log(error);
    }
  };

  const onDragStart = (event, index, questionIndex) => {
    event.dataTransfer.setData('text/plain', index);
    if (selectedQuestionIndex == questionIndex)
      setIsDragging(true);
    else
      setIsDragging(false);
  };

  const onDragOver = (event, index) => {
    event.preventDefault();
    setDropIndex(index);
  };

  const onDragLeave = () => {
    setDropIndex(null);
  };

  const onDrop = (event, index) => {
    event.preventDefault();
    if (selectedQuestionIndex + 1 != index)
      handleMoveQuestion(selectedQuestionIndex + 1, index);
    setDropIndex(null);
    setIsDragging(false);
  };

  const handleMoveQuestion = async (currentPosition, newPosition) => {
    if (questionCount > 1) {
      setIsLoading(true);
      let option = {
        assignmentId: Id,
        currentPosition: currentPosition,
        newPosition: newPosition
      };
      try {
        const response = await moveQuestion(option).unwrap();
        if (response) {
          CustomToast('Question Moved Successfully', 'success');
          getQuestionDetailsHandler(newPosition - 1);
        } else {
          CustomToast('Question Moved Failed', 'error');
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
        CustomToast(error.data.error, 'error');
      }
    }
    setPAGE_SIZE(questionsPerPage);
  };

  const handleRemoveQuestion = async () => {
    setIsLoading(true);
    setConfirmModel(false);
    let option = {
      assignmentId: Id,
      questionNo: selectedQuestionIndex + 1
    };
    try {
      const response = await removeQuestion(option);
      if (response?.error) {
        if (response.error.data?.error)
          CustomToast(response.error.data.error, 'error');
        else
          CustomToast('Question Delete Failed', 'error');
        setIsLoading(false);
        return;
      }

      if (questionCount == selectedQuestionIndex + 1) {
        getQuestionDetailsHandler(selectedQuestionIndex - 1);
      } else {
        getQuestionDetailsHandler(selectedQuestionIndex);
      }
      getPreviewHandler();
      CustomToast('Question Deleted Successfully', 'success');

      if (pageQuestionIds?.length == 1) {
        handlePrevPage(true);
        getQuestionDetailsHandler(selectedQuestionIndex - 1);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      CustomToast('Question Delete Failed', 'error');
    }
  };

  const handleReorderQuestion = async () => {
    setConfirmModel(false);
    if (questionCount > 1) {
      setIsLoading(true);
      let option = {
        assignmentId: Id
      };
      try {
        const response = await reorderQuestion(option).unwrap();
        if (response) {
          CustomToast('Question Shuffled Successfully', 'success');
          getQuestionDetailsHandler(selectedQuestionIndex);
        } else {
          CustomToast('Question Shuffled Failed', 'error');
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
        CustomToast(error.data.error, 'error');
      }
    }
  };

  const nextQuestionHandler = () => {
    const modalContentEl = document.querySelector('.assignment-review-header');
    const firstQuestionEl = modalContentEl.querySelector('p');
    firstQuestionEl.scrollIntoView({ behavior: 'smooth', top: '0' });
    if (selectedQuestionIndex < questions?.questionIds?.length - 1) {
      getQuestionDetailsHandler(selectedQuestionIndex + 1);
    }
    if (endIndex === selectedQuestionIndex + 1) setCurrentPage(currentPage + 1);
  };

  function handlePrevPage(isLastQuestion = false) {
    setCurrentPage(currentPage - 1);
    if (!isDragging && !isLastQuestion)
      setQSetChange(!qSetChange);
  }

  function handleNextPage() {
    setCurrentPage(currentPage + 1);
    if (!isDragging)
      setQSetChange(!qSetChange);
  }

  const handleAssignToStudents = () => {
    if (!assignmentAssignedViaDetails.id) {
      setShowAssignmentMethodModal(true);
      setAssignedViaNeedsSet(true);
    } else {
      navigate(`/assignments/${Id}/manage_assign/assign_to_students`);
    }
  };

  return (
    <>
      <div>
        <>
          <div>
            <AssignmentPreviewHeader
              assignmentName={questions?.assignmentName}
              numberOfQuestions={`${questionCount > 0 ? `${selectedQuestionIndex + 1}/${questionCount}` : 0}`}
              courseName={questions?.courseName}
              verificationNumber={questions?.verificationNumber}
              type={QuestionPreviewTypes.editAssignmentPreview}
              createdDate={questions?.createdDate !== undefined ? DateFormatter.toShortDate(questions?.createdDate) : ''}
            />
          </div>

          <div className="assignment-review-content d-flex align-items-start mb-2 gap-4 mt-3 edit-assignment-layout">
            <div className="questions-numbers edit flex-shrink-0 edit-assignment-sidebar">
              <div className="border-grey white-card">
                <div className="justify-content-between">
                  <div className="classroom-content">
                    <div className={`classroom-content-box ${questionOpen && 'open'}`}>
                      <div className="classroom-content-header justify-content-between align-item-center d-flex pb-0 cursor-pointer" onClick={() => setQuestionOpen(!questionOpen)}>
                        <h6 className='align-content-center mb-0 no-select'>Questions</h6>
                        <button className="z-index10 grey-clr">
                          <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                      </div>
                      {questionOpen && (
                        <div className="mt-2">
                          {numPages > 1 && (
                            <>
                              <ul
                                className="flex-row gap-2 justify-content-end pb-2 d-flex">
                                <li className='bg-body'>
                                  <button
                                    onClick={handlePrevPage}
                                    onDragEnter={isDragging && handlePrevPage}
                                    className={`btn btn-castleWhite px-3 ${currentPage === 0 && 'disabled'}`}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                  </button>
                                </li>
                                <li className='bg-body'>
                                  <button
                                    onClick={handleNextPage}
                                    onDragEnter={isDragging && handleNextPage}
                                    className={`btn btn-castleWhite px-3 ${currentPage === numPages - 1 && 'disabled'}`}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                  </button>
                                </li>
                              </ul>
                            </>
                          )}
                          <ul className="d-flex flex-wrap m-0 p-0 gap-2">
                            {pageQuestionIds?.map((question, index) => {
                              const questionIndex = startIndex + index;
                              return (
                                <>
                                  <li
                                    key={questionIndex}
                                    onClick={() => getQuestionDetailsHandler(questionIndex)}
                                    {
                                      ...assignedStatus > 3 && (isDragging || selectedQuestionIndex == questionIndex) &&
                                    {
                                      draggable: true,
                                      onDragStart: (e) => onDragStart(e, index, questionIndex),
                                      onDragOver: (e) => onDragOver(e, index),
                                      onDrop: (e) => onDrop(e, questionIndex + 1),
                                      onDragLeave: onDragLeave,
                                    }
                                    }
                                    className={`${selectedQuestionIndex == questionIndex && 'active'} cursor-grab question-list-item`}>
                                    {dropIndex === index ?
                                      <div className='w-40 h-40'></div> : <a>{questionIndex + 1}</a>
                                    }
                                  </li>
                                  {dropIndex === index && (questionIndex + 1 != endIndex && questionIndex + 1 != questionCount) && (
                                    <div className="question-tile justify-content-center d-flex align-items-center p-1 w-40 h-40">
                                      <a>{questionIndex + 1}</a>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </ul>
                          <div className="mt-3">
                            <span>Drag and drop to reorder question</span>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                  To change the position of the question use the Drag and Drop
                                  feature.<br></br><br></br>
                                  To view more question tiles drag over to Next & Previous Buttons.
                                </Tooltip>
                              }>
                              <FontAwesomeIcon
                                className="circle-question mx-1"
                                icon={faCircleQuestion}
                              />
                            </OverlayTrigger>
                          </div>
                          <div className="w-100">
                            <button
                              className={`btn btn-castleWhite mr-2 mt-3 w-30 ${(assignedStatus <= 3 || questionCount >= 100) && 'disabled'}`}
                              onClick={() => navigate('/questionsSearch/assignment/' + Id + '/castle_questions/questions')}>
                              <FontAwesomeIcon icon={faPlus} className="px-1" />
                              Add
                            </button>
                            <button
                              className={`btn btn-castleWhite mr-2 mt-3 w-30 ${questionCount <= 1 && 'disabled'
                              }`}
                              onClick={() => {
                                SetConfirmModelSelected('delete');
                                setConfirmModel(true);
                              }}>
                              <FontAwesomeIcon icon={faTrashAlt} className="px-1" />
                              Remove
                            </button>
                            <button
                              className={`btn btn-castleWhite mt-3 w-33 ${(assignedStatus <= 3 || questionCount <= 1) && 'disabled'
                              }`}
                              onClick={() => {
                                SetConfirmModelSelected('shuffle');
                                setConfirmModel(true);
                              }}>
                              <FontAwesomeIcon icon={faShuffle} className="px-1" />
                              Shuffle
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="line"></div>
                <EditAssignmentOptionsModal
                  assignmentInfo={questions}
                  setQuestions={setQuestions}
                  selectedMcStyle={parseInt(selectedMcStyle)}
                  setSelectedMcStyle={setSelectedMcStyle}
                  mcChoices={mcChoices}
                  currentQuestionId={currentQuestionId}
                  questionCourseId={questionCourseId}
                  isBlockedQuestion={isBlockedQuestion}
                />
              </div>
              <div className="d-flex mt-3 edit-assignment-actions">
                {questionCount > 0 &&
                <div className="cursor-pointer mr-2 mt-3 w-50 grey-icon edit-assignment-action-item" onClick={() => handleAssignToStudents()}>
                  <FontAwesomeIcon icon={faUserGraduate} className="px-1" />
                  Assign To Students
                </div>
                }
                <div className={`cursor-pointer mt-3 grey-icon edit-assignment-action-item ${questionCount > 0 ? 'w-50' : 'w-100'}`} onClick={() => navigate(`/assignments/${Id}/manage_assign/reports/assignment_changes_report`)}>
                  <FontAwesomeIcon icon={faChartPie} className="px-1" />
                  Assignment Changes Report
                </div>
              </div>
            </div>
            <div className="d-flex flex-column w-75 white-card edit-assignment-detail-panel">
              {questionCount > 0 ?(
                <QuestionDetail
                  questionDetails={questionDetails}
                  setQuestionDetails={setQuestionDetails}
                  nextQuestionHandler={nextQuestionHandler}
                  selectedQuestionId={selectedQuestionIndex}
                  lastQuestion={questionCount === selectedQuestionIndex + 1 ? true : false}
                  isLoading={isLoading}
                  mcStyle={selectedMcStyle}
                  assignedStatus={assignedStatus}
                  assignmentId={Id}
                  questionCount={questionCount}
                  type={QuestionPreviewTypes.editAssignmentPreview}
                  assignmentName={questions.assignmentName}
                  setAssignmentDetails={setQuestions}
                  assignmentDetails={questions}
                />
              ):(
                <>
                  {!isLoading && questionCount == 0 &&
                  <div className='p-5 fs-5'>
                    There are no questions in this assignment.<br/>
                    Add questions by clicking <strong>Add</strong> from the options on the left.
                  </div>
                  }
                </>
              )}
            </div>
          </div>
          {assignedStatus <= 3 && (
            <div className="scoreInfo d-flex col-12">
              <div className="scoreInfoIcon info-text">
                <span>
                  <FontAwesomeIcon icon={faInfo} />
                </span>
              </div>
              <div className="scoreInfoText justify-text">
                <p>
                  This assignment has limited modification allowed because it has been assigned to
                  one or more students. You can delete questions (if not randomized) but not add
                  new ones.&nbsp;
                  <strong>
                    <br></br>
                    If Question Options is not displayed verify that no removed students are
                    assigned by checking the box on the assignment results page.
                  </strong>{' '}
                  If you would like to create a new assignment using some or all of these
                  questions, create a new assignment, select the Add Question option, then select
                  the Your Assignments tab, select this assignment, then select some or all of the
                  questions to be added to the new assignment.
                </p>
              </div>
            </div>
          )}
        </>
      </div>

      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={
          confirmModelSelected == 'delete'
            ? handleRemoveQuestion
            : confirmModelSelected == 'shuffle' && handleReorderQuestion
        }
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          confirmModelSelected == 'delete'
            ? `Are you sure that you want to Remove Question ${selectedQuestionIndex + 1
            } from the Assignment?`
            : confirmModelSelected == 'shuffle' &&
            'Are you sure that you want to have the order of the Questions Randomly Changed?'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />

      <AssignedViaModal showModal={showAssignmentMethodModal} setShowModal={setShowAssignmentMethodModal} assignmentId={Id} />
    </>
  );
}

export default EditAssignment;
